import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay";
import { SoftwareGuardPricingPage } from "../pages/software/guard/pricing/software-guard-pricing-page";

initRelay(
    SoftwareGuardPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars("atlassian-access", window.location),
    RELAY_API_CONTENTFUL
);
